import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=5da5da87&scoped=true&"
import script from "./risk.vue?vue&type=script&lang=js&"
export * from "./risk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5da87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5da5da87')) {
      api.createRecord('5da5da87', component.options)
    } else {
      api.reload('5da5da87', component.options)
    }
    module.hot.accept("./risk.vue?vue&type=template&id=5da5da87&scoped=true&", function () {
      api.rerender('5da5da87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/thirdData/risk.vue"
export default component.exports